var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ProductionDesignInitiativeApplicationCancel.jinja');
require('./ProductionDesignInitiativeApplicationCancel.less');


module.exports = Base.extend({

    template: template,

    events: {
        'click .ProductionDesignInitiativeApplicationCancel-yesButton': 'onYesClick',
        'click .ProductionDesignInitiativeApplicationCancel-noButton': 'onNoClick',
        'click': 'onBGClick'
    },


    initialize: function (options) {

        _.bindAll(this, 'onKeyDown');

        Base.prototype.initialize.call(this, options);
    },


    show: function (params) {
        params = params || {};

        $('body').on('keydown', this.onKeyDown);

        this.cb = params.cb;
        this.$el.addClass('ProductionDesignInitiativeApplicationCancel--visible');
    },


    hide: function () {
        $('body').off('keydown', this.onKeyDown);

        this.$el.removeClass('ProductionDesignInitiativeApplicationCancel--visible');
    },


    onBGClick: function (e) {
        if ($(e.target).closest('.ProductionDesignInitiativeApplicationCancel-body').length) return;

        this.onNoClick();
    },

    onKeyDown: function (e) {
        if (e.keyCode == 27) { //esc
            e.stopPropagation();

            this.onNoClick();
        }
    },


    onNoClick: function () {
        this.hide();

        this.cb && this.cb(false);
    },


    onYesClick: function () {
        this.hide();

        this.cb && this.cb(true);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionDesignInitiativeApplicationCancel/ProductionDesignInitiativeApplicationCancel.js
// module id = 235
// module chunks = 0